import Vue from 'vue'

export const EventBus = new Vue()

export function _buildQuery(params) {
    let string = ''

    for (let key in params){
        if(params[key] !== ""){
            string += `${key}=${params[key]}&`
        }
    }
    string = '?'+string.substring(0, string.length - 1)
    return string;
}

export function _buildQueryCustom(params) {
  let string = ''

  for (let key in params){
    if(params[key] !== ""){
      string += `&${key}=${params[key]}`
    }
  }
  //string = '?'+string.substring(0, string.length - 1)
  return string;
}

export function format(num){
  return String(num).replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1 ');
}
